export default __webpack_public_path__ + "KaTeX_Caligraphic-Bold.f046a374a80bb69ba397ad705f607490.woff2";